import apiClient from './client';
import { CreateSectionGuideSchema, UpdateSectionGuideSchema } from 'shared-schemas';

export const sectionGuidesApi = {
  /**
   * List all section guides with pagination.
   */
  list: async (params = {}) => {
    const response = await apiClient.get('/api/section-guides', { params });
    return response.data;
  },

  /**
   * Get all section guides as a map keyed by type.
   */
  getAll: async () => {
    const response = await apiClient.get('/api/section-guides/all');
    return response.data;
  },

  /**
   * Get a single section guide by ID.
   */
  get: async (id) => {
    const response = await apiClient.get(`/api/section-guides/${id}`);
    return response.data;
  },

  /**
   * Create a new section guide.
   */
  create: async (guideData) => {
    const validated = CreateSectionGuideSchema.parse(guideData);
    const response = await apiClient.post('/api/section-guides', validated);
    return response.data;
  },

  /**
   * Update an existing section guide.
   */
  update: async (id, guideData) => {
    const validated = UpdateSectionGuideSchema.parse(guideData);
    const response = await apiClient.patch(`/api/section-guides/${id}`, validated);
    return response.data;
  },

  /**
   * Add an example to a section guide.
   */
  addExample: async (id, example) => {
    const response = await apiClient.post(`/api/section-guides/${id}/examples`, example);
    return response.data;
  },

  /**
   * Remove an example from a section guide.
   */
  removeExample: async (id, exampleIndex) => {
    const response = await apiClient.delete(`/api/section-guides/${id}/examples/${exampleIndex}`);
    return response.data;
  },

  /**
   * Add a rule to a section guide.
   */
  addRule: async (id, rule) => {
    const response = await apiClient.post(`/api/section-guides/${id}/rules`, rule);
    return response.data;
  },

  /**
   * Delete a section guide.
   */
  delete: async (id) => {
    await apiClient.delete(`/api/section-guides/${id}`);
  },
};
